/**
 * notif-prefs.js — Preferencias de notificaciones del usuario (en localStorage).
 *
 * Defaults sensatos:
 *   - Desktop notifications: OFF (requiere consentimiento explícito)
 *   - Sonido para menciones: ON
 *   - Sonido para QC pendiente: ON
 *   - Sonido resto: OFF
 *   - Toast in-tab: ON (siempre)
 */

const LS_KEY = "crew_notif_prefs_v1";

export const DEFAULT_PREFS = {
  // In-tab (sin permisos)
  toast: true,
  titleBar: true,
  favicon: true,
  // Sonido (Web Audio API)
  sound: false,                   // master switch
  soundMention: true,             // si master ON, suena para menciones
  soundQC: true,                  // si master ON, suena para QC pendiente
  soundAsignacion: false,
  soundAprobaciones: false,
  // Desktop (Notification API)
  desktop: false,                 // master switch (requiere permiso)
  desktopMention: true,
  desktopQC: true,
  desktopAsignacion: true,
  desktopAprobaciones: false,
};

export function loadPrefs() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PREFS, ...parsed };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function savePrefs(prefs) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(prefs));
    // Notificar a otros componentes en la misma tab
    window.dispatchEvent(new CustomEvent("crew-notif-prefs-changed", { detail: prefs }));
  } catch (e) {
    console.warn("[notif-prefs] no se pudo guardar:", e.message);
  }
}

/**
 * Devuelve true si una notif de un tipo debe sonar.
 */
export function shouldPlaySound(tipo, prefs = loadPrefs()) {
  if (!prefs.sound) return false;
  if (tipo === "mention" || tipo === "mencion-chat") return prefs.soundMention;
  if (tipo === "para-qc" || tipo === "qc-pendiente") return prefs.soundQC;
  if (tipo === "tarea-asignada" || tipo === "asignacion") return prefs.soundAsignacion;
  if (tipo === "aprobado" || tipo === "revision-cliente") return prefs.soundAprobaciones;
  return false;
}

/**
 * Devuelve true si una notif de un tipo debe disparar desktop notification.
 */
export function shouldShowDesktop(tipo, prefs = loadPrefs()) {
  if (!prefs.desktop) return false;
  if (Notification?.permission !== "granted") return false;
  if (tipo === "mention" || tipo === "mencion-chat") return prefs.desktopMention;
  if (tipo === "para-qc" || tipo === "qc-pendiente") return prefs.desktopQC;
  if (tipo === "tarea-asignada" || tipo === "asignacion") return prefs.desktopAsignacion;
  if (tipo === "aprobado" || tipo === "revision-cliente") return prefs.desktopAprobaciones;
  return false;
}
